// Local Variables
const numberOfVisibleFlags = 6;

// Module Exports
export { numberOfVisibleFlags };
